/*
 * Transições Vision 2025
 * Animações do Vision antigo (base Warehouse) adaptadas ao Vision atual (base Horizon).
 * Carregado apenas quando "Pacote de transições" = Transições Vision 2025.
 *
 * Recursos (cada um liga/desliga nas configurações do tema):
 *  vt25-produtos  produtos e coleções aparecem um por um
 *  vt25-secoes    banners e seções revelados ao rolar
 *  vt25-midia     imagem principal e miniaturas da página do produto
 *  vt25-slides    textos sobem a cada troca de slide
 *  vt25-parallax  parallax no banner (hero)
 *  vt25-gavetas   itens do carrinho lateral, megamenu (o resto é CSS)
 *
 * Tempos e curvas iguais aos do tema antigo.
 */
(function () {
  'use strict';

  var root = document.documentElement;
  if (!root.classList.contains('vt25')) return;

  function liberar() {
    root.classList.remove('vt25-wait');
  }

  var temMovimento = root.classList.contains('vt25-motion') && typeof Element.prototype.animate === 'function';
  if (!temMovimento) {
    liberar();
    return;
  }

  function ligado(nome) {
    return root.classList.contains('vt25-' + nome);
  }

  var CURVA = {
    imagem: 'cubic-bezier(0.65, 0, 0.35, 1)',
    texto: 'cubic-bezier(0.5, 0.06, 0.01, 0.99)',
    itens: 'cubic-bezier(0.25, 1, 0.5, 1)',
    recolhivel: 'cubic-bezier(0.75, 0, 0.175, 1)',
    vazio: 'cubic-bezier(0.33, 1, 0.68, 1)',
  };

  var SEL_TEXTO =
    '.text-block, .button, .button-secondary, a.link, .jumbo-text, .email-signup-block, .xss-title, .xss-text, .xss-button';
  var SEL_ITEM = '.product-grid__item, .resource-list__item';
  var SEL_LISTA = '.product-grid, .resource-list__carousel, .resource-list, .section-resource-list__content, .shopify-section';

  var processados = new WeakSet();
  var main = document.getElementById('MainContent');
  var template = (main && main.getAttribute('data-template')) || '';

  /* ---------------- utilidades ---------------- */

  function lista(nodeList) {
    return Array.prototype.slice.call(nodeList || []);
  }

  function esconder(el) {
    el.style.opacity = '0';
  }

  // Toca a animação mantendo o primeiro quadro durante o atraso (fill: backwards)
  function animar(el, quadros, opcoes) {
    if (!el) return null;
    var op = { fill: 'backwards' };
    for (var k in opcoes) op[k] = opcoes[k];
    var anim = el.animate(quadros, op);
    el.style.opacity = '';
    return anim;
  }

  function mobile() {
    return window.innerWidth < 1000;
  }

  // Atraso em cascata do tema antigo: i*passo - min(i*k*i, i*passo)
  function cascata(i, passo, k) {
    return i * passo - Math.min(i * k * i, i * passo);
  }

  function quandoVisivel(el, fn, opcoes) {
    if (!('IntersectionObserver' in window)) {
      fn();
      return;
    }
    var altura = el.clientHeight;
    var io = new IntersectionObserver(
      function (entradas) {
        if (entradas[0].isIntersecting) {
          io.disconnect();
          requestAnimationFrame(fn);
        }
      },
      opcoes || { rootMargin: '30px 0px', threshold: altura > 0 ? Math.min(50 / altura, 1) : 0 }
    );
    io.observe(el);
  }

  function imagemCarregada(img) {
    return new Promise(function (ok) {
      if (!img || img.tagName !== 'IMG' || img.complete) return ok();
      var fim = function () {
        ok();
      };
      img.addEventListener('load', fim, { once: true });
      img.addEventListener('error', fim, { once: true });
      setTimeout(fim, 1500);
    });
  }

  // Blocos de texto/botão sem repetir um que já está dentro de outro
  function folhas(container) {
    if (!container) return [];
    var todos = lista(container.querySelectorAll(SEL_TEXTO)).filter(function (el) {
      return !el.closest('product-card, .product-card, .resource-list__item, .product-grid__item, .xss-arrow, .xss-dots');
    });
    return todos.filter(function (el) {
      return !todos.some(function (outro) {
        return outro !== el && outro.contains(el);
      });
    });
  }

  function primeiraMidia(container, fora) {
    if (!container) return null;
    var midias = lista(container.querySelectorAll('img, video, .placeholder-image, svg.placeholder-svg'));
    for (var i = 0; i < midias.length; i++) {
      var m = midias[i];
      if (fora && fora.contains(m)) continue;
      if (m.offsetParent === null && m.tagName !== 'VIDEO') continue;
      return m;
    }
    return null;
  }

  /* ---------------- receitas do tema antigo ---------------- */

  // Imagem com texto / banner: imagem 1.1 → 1 (500ms) e depois as linhas de texto sobem (300ms, +120ms cada)
  function receitaBanner(alvo, midias, textos) {
    midias = midias.filter(Boolean);
    midias.forEach(esconder);
    textos.forEach(esconder);
    quandoVisivel(alvo, function () {
      Promise.all(midias.map(imagemCarregada)).then(function () {
        midias.forEach(function (m) {
          animar(m, { opacity: [0, 1], transform: ['scale(1.1)', 'scale(1)'] }, { duration: 500, easing: CURVA.imagem });
        });
        var base = midias.length ? 500 : 0;
        textos.forEach(function (t, i) {
          animar(
            t,
            {
              opacity: [0, 0.2, 1],
              transform: ['translateY(100%)', 'translateY(0)'],
              clipPath: ['inset(0 0 100% 0)', 'inset(0 0 0 0)'],
            },
            { duration: 300, delay: base + i * 120, easing: CURVA.texto }
          );
        });
      });
    });
  }

  // Colunas / blocos: sobem 60px (35px no mobile) em 600ms, +100ms cada
  function receitaColunas(alvo, itens) {
    itens.forEach(esconder);
    quandoVisivel(alvo, function () {
      var d = mobile() ? 35 : 60;
      itens.forEach(function (el, i) {
        animar(
          el,
          { opacity: [0, 1], transform: ['translateY(' + d + 'px)', 'translateY(0)'] },
          { duration: 600, delay: i * 100, easing: 'ease' }
        );
      });
    });
  }

  /* ---------------- 1. Produtos e coleções um por um ---------------- */

  function prepararGrades(escopo) {
    if (!ligado('produtos') || !escopo) return;

    var itens = lista(escopo.querySelectorAll(SEL_ITEM));
    // Cards de produto fora das listas padrão (seções personalizadas)
    lista(escopo.querySelectorAll('product-card')).forEach(function (card) {
      if (!card.closest(SEL_ITEM)) itens.push(card);
    });

    var grupos = new Map();
    itens.forEach(function (item) {
      if (processados.has(item)) return;
      if (item.closest('dialog, .menu-drawer, header, [data-vt25-pular]')) return;
      processados.add(item);
      var lista_ = (item.parentElement && item.parentElement.closest(SEL_LISTA)) || item.parentElement;
      if (!grupos.has(lista_)) grupos.set(lista_, []);
      grupos.get(lista_).push(item);
    });

    grupos.forEach(function (grupo, container) {
      var colecoes = grupo.filter(function (it) {
        return it.querySelector('.collection-card');
      });
      if (colecoes.length === grupo.length) {
        receitaColecoes(container, grupo);
      } else {
        receitaProdutos(container, grupo);
      }
    });
  }

  // Antigo product-list: sobe 60px (35 no mobile), 600ms "ease", atraso i*100 - min(3i², 100i)
  function receitaProdutos(container, itens) {
    itens.forEach(esconder);
    var h = container.clientHeight;
    quandoVisivel(
      container,
      function () {
        var d = mobile() ? 35 : 60;
        itens.forEach(function (el, i) {
          animar(
            el,
            { opacity: [0, 1], transform: ['translateY(' + d + 'px)', 'translateY(0)'] },
            { duration: 600, delay: cascata(i, 100, 3), easing: 'ease' }
          );
        });
      },
      { rootMargin: '30px 0px', threshold: h > 0 ? Math.min(50 / h, 1) : 0 }
    );
  }

  // Antigo collection-list: imagem 1.1 → 1 (250ms, +150ms cada), depois os textos sobem (200ms)
  function receitaColecoes(container, itens) {
    var partes = itens.map(function (item) {
      var midia = item.querySelector('img, .placeholder-image, svg');
      var textos = folhas(item.querySelector('.collection-card__content') || item);
      if (!midia) textos = [item];
      return { midia: midia, textos: textos };
    });
    partes.forEach(function (p) {
      if (p.midia) esconder(p.midia);
      p.textos.forEach(esconder);
    });
    quandoVisivel(container, function () {
      partes.forEach(function (p, i) {
        if (p.midia) {
          animar(
            p.midia,
            { opacity: [0, 1], transform: ['scale(1.1)', 'scale(1)'] },
            { duration: 250, delay: i * 150, easing: CURVA.imagem }
          );
        }
        var inicio = p.midia ? i * 150 + 250 : 0;
        p.textos.forEach(function (t, j) {
          animar(
            t,
            {
              opacity: [0, 1],
              clipPath: ['inset(0 0 100% 0)', 'inset(0 0 0 0)'],
              transform: ['translateY(100%)', 'translateY(0)'],
            },
            { duration: 200, delay: inicio + i * 150 + j * 150, easing: CURVA.texto }
          );
        });
      });
    });
  }

  /* ---------------- 2. Seções reveladas ao rolar ---------------- */

  function pularSecao(secao) {
    if (secao.hasAttribute('data-vt25-pular') || secao.querySelector('[data-vt25-pular]')) return true;
    if (/^(cart|customers|password|gift_card)/.test(template)) return true;
    if (secao.querySelector('media-gallery, product-information, .product-information, cart-items-component, form[action*="/account"]')) {
      return true;
    }
    if (secao.querySelector(SEL_ITEM + ', product-card')) return true; // grades já animadas pelos produtos
    return false;
  }

  function prepararSecoes() {
    if (!ligado('secoes') || !main) return;

    lista(main.children).forEach(function (secao) {
      if (!secao.classList.contains('shopify-section') || processados.has(secao)) return;
      processados.add(secao);
      if (pularSecao(secao)) return;

      // Banner (hero)
      var hero = secao.querySelector('.hero');
      if (hero) {
        var conteudoHero = hero.querySelector('.hero__content-wrapper');
        receitaBanner(
          hero,
          lista(hero.querySelectorAll('.hero__media-wrapper img, .hero__media-wrapper video')).filter(function (m) {
            return m.offsetParent !== null || m.tagName === 'VIDEO';
          }),
          folhas(conteudoHero)
        );
        return;
      }

      // Imagem com texto
      var mwc = secao.querySelector('.media-with-content');
      if (mwc) {
        var conteudo = mwc.querySelector('.media-with-content__content');
        receitaBanner(mwc, [primeiraMidia(mwc, conteudo)], folhas(conteudo));
        return;
      }

      // Slideshow personalizado Vision (slideshow-v)
      var xss = secao.querySelector('.xss-section');
      if (xss) {
        var ativo = xss.querySelector('.xss-slide.is-active') || xss.querySelector('.xss-slide');
        receitaBanner(xss, [ativo && ativo.querySelector('.xss-img, img, video')], folhas(ativo));
        return;
      }

      // Slideshow nativo
      var slideshow = secao.querySelector('slideshow-component');
      if (slideshow && !slideshow.closest('.resource-list__carousel')) {
        var slide = slideshow.querySelector('slideshow-slide:not([aria-hidden="true"])') || slideshow.querySelector('slideshow-slide');
        receitaBanner(slideshow, [primeiraMidia(slide)], folhas(slide));
        return;
      }

      // Seção genérica montada com blocos
      var conteudoSecao = secao.querySelector('.custom-section-content');
      var itens = conteudoSecao ? lista(conteudoSecao.children) : [];
      itens = itens.filter(function (el) {
        return el.nodeType === 1 && !/^(STYLE|SCRIPT|TEMPLATE)$/.test(el.tagName) && el.offsetParent !== null;
      });
      if (!itens.length) {
        var raiz = lista(secao.children).filter(function (el) {
          return !/^(STYLE|SCRIPT|TEMPLATE|LINK)$/.test(el.tagName) && el.offsetHeight > 0;
        });
        itens = raiz.length ? [raiz.length === 1 ? raiz[0] : secao] : [];
      }
      if (itens.length) receitaColunas(secao, itens);
    });
  }

  /* ---------------- 3. Mídia da página do produto ---------------- */

  function prepararMidiaProduto() {
    if (!ligado('midia') || !main) return;
    lista(main.querySelectorAll('media-gallery')).forEach(function (galeria) {
      if (processados.has(galeria)) return;
      processados.add(galeria);

      // A galeria tem uma versão desktop e outra mobile (uma fica oculta).
      // Usa o primeiro slide que está visível na tela atual.
      var principal = null;
      var slides = lista(galeria.querySelectorAll('slideshow-slide, .media-gallery__grid > li'));
      for (var s = 0; s < slides.length && !principal; s++) principal = primeiraMidia(slides[s]);
      var miniaturas = lista(galeria.querySelectorAll('.slideshow-controls__thumbnail')).filter(function (m) {
        return m.offsetParent !== null;
      });
      var lista_ = miniaturas[0] && miniaturas[0].parentElement;
      var vertical = lista_ && /column/.test(getComputedStyle(lista_).flexDirection);

      if (principal) esconder(principal);
      miniaturas.forEach(esconder);

      quandoVisivel(galeria, function () {
        imagemCarregada(principal).then(function () {
          if (principal) {
            animar(
              principal,
              { opacity: [0, 1], transform: ['scale(1.1)', 'scale(1)'] },
              { duration: 500, easing: CURVA.imagem }
            );
          }
          miniaturas.forEach(function (m, i) {
            animar(
              m,
              {
                opacity: [0, 1],
                transform: vertical ? ['translateY(40px)', 'translateY(0)'] : ['translateX(50px)', 'translateX(0)'],
              },
              { duration: 250, delay: i * 100, easing: CURVA.recolhivel }
            );
          });
        });
      });
    });
  }

  /* ---------------- 4. Textos dos slides ---------------- */

  function animarTextosSlide(slide) {
    folhas(slide).forEach(function (t, i) {
      animar(
        t,
        {
          opacity: [0, 1],
          clipPath: ['inset(0 0 100% 0)', 'inset(0 0 0 0)'],
          transform: ['translateY(100%)', 'translateY(0)'],
        },
        { duration: 450, delay: i * 100, easing: CURVA.texto }
      );
    });
  }

  function prepararSlides() {
    if (!ligado('slides')) return;

    document.addEventListener('slideshow:select', function (e) {
      var slide = e.detail && e.detail.slide;
      if (!slide || !(slide instanceof Element)) return;
      if (e.detail.index === e.detail.previousIndex) return;
      if (slide.closest('media-gallery, product-card, .product-card, .resource-list__carousel, dialog, .card-gallery')) return;
      animarTextosSlide(slide);
    });

    // slideshow-v troca a classe is-active
    var obs = new MutationObserver(function (mudancas) {
      mudancas.forEach(function (m) {
        var el = m.target;
        if (
          el.classList &&
          el.classList.contains('xss-slide') &&
          el.classList.contains('is-active') &&
          !(m.oldValue || '').split(/\s+/).includes('is-active')
        ) {
          animarTextosSlide(el);
        }
      });
    });
    lista(document.querySelectorAll('.xss-slide')).forEach(function (s) {
      obs.observe(s, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
    });
  }

  /* ---------------- 5. Parallax no banner ---------------- */

  function prepararParallax() {
    if (!ligado('parallax') || !main) return;
    var heros = lista(main.querySelectorAll('.hero'));
    if (!heros.length) return;
    heros.forEach(function (h) {
      h.setAttribute('data-vt25-parallax', '');
    });
    var pendente = false;
    function alturaCabecalho() {
      var cab = document.getElementById('header-group');
      return cab ? cab.offsetHeight : 0;
    }
    function atualizar() {
      pendente = false;
      var hc = alturaCabecalho();
      heros.forEach(function (hero) {
        var r = hero.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var conteudo = hero.querySelector('.hero__content-wrapper');
        var midia = hero.querySelector('.hero__media-wrapper');
        if (conteudo) {
          conteudo.style.opacity = String(Math.max(1 - (1 - Math.min(r.bottom / r.height, 1)) * 3, 0));
        }
        if (midia) {
          midia.style.transform = 'translateY(' + (100 - Math.max(Math.min(r.bottom / (r.height + hc), 1), 0) * 100) + 'px)';
        }
      });
    }
    window.addEventListener(
      'scroll',
      function () {
        if (!pendente) {
          pendente = true;
          requestAnimationFrame(atualizar);
        }
      },
      { passive: true }
    );
    atualizar();
  }

  /* ---------------- 6. Carrinho lateral e megamenu ---------------- */

  // Antigo cart-drawer: itens entram da direita (400ms, atraso 400 + i*120 - min(2i², 120i)),
  // rodapé sobe (300ms, atraso 400), recomendações entram da direita no desktop.
  function animarCarrinhoAberto(dialogo) {
    var desktop = window.matchMedia('(min-width: 750px)').matches;
    var itens = lista(dialogo.querySelectorAll('.cart-items__table-row'));
    var recomendados = dialogo.querySelector('.cart-drawer__recommendations-column');
    var rodape = dialogo.querySelector('.cart-drawer__summary');
    if (recomendados && !desktop) itens.push(recomendados);

    itens.forEach(function (el, i) {
      animar(
        el,
        { opacity: [0, 1], transform: ['translateX(40px)', 'translateX(0)'] },
        { duration: 400, delay: 400 + cascata(i, 120, 2), easing: CURVA.itens }
      );
    });
    if (rodape) {
      animar(
        rodape,
        { opacity: [0, 1], transform: ['translateY(100%)', 'translateY(0)'] },
        { duration: 300, delay: 400, easing: CURVA.itens }
      );
    }
    if (recomendados && desktop && recomendados.offsetParent !== null) {
      animar(
        recomendados,
        { opacity: [0, 1], transform: ['translateX(100%)', 'translateX(0)'] },
        { duration: 250, delay: 400 + Math.max(itens.length * 120 - itens.length * 25, 25), easing: CURVA.itens }
      );
    }
  }

  function prepararGavetas() {
    if (!ligado('gavetas')) return;

    // Abertura do carrinho lateral (o evento dialog:open não borbulha, então usamos captura)
    document.addEventListener(
      'dialog:open',
      function (e) {
        var comp = e.target;
        if (!(comp instanceof Element) || !comp.matches('cart-drawer-component, .cart-drawer')) return;
        var dialogo = comp.querySelector('dialog');
        if (!dialogo) return;
        var conteudo = dialogo.querySelector('.cart-drawer__content');
        if (conteudo) conteudo.scrollTop = 0;
        animarCarrinhoAberto(dialogo);
      },
      true
    );

    // Carrinho ficou vazio com a gaveta aberta: conteúdo vazio sobe 40px (450ms)
    var obsVazio = new MutationObserver(function (mudancas) {
      mudancas.forEach(function (m) {
        lista(m.addedNodes).forEach(function (n) {
          if (n.nodeType !== 1) return;
          var titulo = n.matches('.cart-drawer__heading--empty') ? n : n.querySelector('.cart-drawer__heading--empty');
          var dialogo = titulo && titulo.closest('dialog[open]');
          if (!dialogo) return;
          var conteudo = titulo.closest('.cart-drawer__content') || titulo;
          animar(
            conteudo,
            { opacity: [0, 1], transform: ['translateY(40px)', 'translateY(0)'] },
            { duration: 450, easing: CURVA.vazio }
          );
        });
      });
    });
    lista(document.querySelectorAll('cart-drawer-component, .cart-drawer')).forEach(function (c) {
      obsVazio.observe(c, { childList: true, subtree: true });
    });

    // Índice das colunas do megamenu (usado no atraso do CSS)
    lista(document.querySelectorAll('.mega-menu__list')).forEach(function (ul) {
      lista(ul.children).forEach(function (li, i) {
        li.style.setProperty('--vt25-i', i);
      });
    });
  }

  /* ---------------- início ---------------- */

  function iniciar() {
    try {
      prepararMidiaProduto();
      prepararGrades(main);
      prepararSecoes();
    } finally {
      liberar();
    }
    prepararSlides();
    prepararParallax();
    prepararGavetas();

    // Produtos que chegam depois (rolagem infinita, filtros, abas)
    if (main && ligado('produtos')) {
      var espera = null;
      new MutationObserver(function () {
        clearTimeout(espera);
        espera = setTimeout(function () {
          prepararGrades(main);
        }, 50);
      }).observe(main, { childList: true, subtree: true });
    }

    // Editor de temas: seção recarregada aparece sem animação
    document.addEventListener('shopify:section:load', function (e) {
      var secao = e.target;
      if (secao && secao.nodeType === 1) {
        processados.add(secao);
        lista(secao.querySelectorAll(SEL_ITEM + ', product-card, media-gallery')).forEach(function (el) {
          processados.add(el);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
